window.canRunAds = true;
